import 'css/app.css';
import 'scss/app.scss';
import 'stylus/app.styl';

// Scripts
import Buttons from './Buttons';
import Images from './Images';
import Navigation from './Navigation';

// Vendors

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Start our scripts
        new Buttons();
        new Images();
        //new Navigation();

    });

})(jQuery);